
export type GeoPosition = {
  lat: number
  lng: number
}


export const Species = (t: (name: string) => string) => [
  { value: "Torsk", label: t("Species.Torsk") },
  { value: "Hyse", label: t("Species.Hyse") },
  { value: "Sei", label: t("Species.Sei") },
  { value: "Makrell", label: t("Species.Makrell") },
  { value: "Sild", label: t("Species.Sild") },
  { value: "Uer (vanlig)", label: t("Species.Uer (vanlig)") },
  { value: "Lyr", label: t("Species.Lyr") },
  { value: "Breiflabb", label: t("Species.Breiflabb") },
  { value: "Lange", label: t("Species.Lange") },
  { value: "Berggylt", label: t("Species.Berggylt") },
];